import { Http } from '@mygpt/app/http';
import { requireSharedIntegration } from '@mygpt/app/config/integrations';

/**
 * 数字人信息接口
 */
export interface AvatarByUuidResponse {
  /** 数字人名称 */
  name: string;
  /** 用途描述 */
  purpose: string;
  /** 公司网址 */
  company_url?: string;
  /** 纹理文件URL */
  texture_url: string;
  /** 公司信息markdown文件URL */
  company_markdown_url?: string | null;
}

/**
 * 根据UUID获取数字人信息
 * @param uuid 数字人UUID
 * @returns 数字人信息
 */
export const getAvatarByUuid = async (uuid: string): Promise<AvatarByUuidResponse> => {
  requireSharedIntegration('Avatar');
  const { get } = Http.use();
  const response = await get<AvatarByUuidResponse>(`https://avatar.gbase.ai/api/get_avatar_by_uuid/${uuid}`);
  return response.data;
};
